const firebaseConfig = {
  apiKey: "AIzaSyCqetrw9Z_glK5yoLRwA10WG3ZJVZSFZFg",
  authDomain: "motorcycle-51d03.firebaseapp.com",
  projectId: "motorcycle-51d03",
  storageBucket: "motorcycle-51d03.appspot.com",
  messagingSenderId: "525315384455",
  appId: "1:525315384455:web:297c64a2d52dedc0e0c422"
};

export default firebaseConfig;